import { createActions } from 'redux-actions';
import selectors from './selectors';

const TRACK = 'DESIGN_PRO/TRACKING/TRACK';
const IDENTIFY = 'DESIGN_PRO/TRACKING/IDENTIFY';
const TRACK_ATTRIBUTE_SELECTION =
  'DESIGN_PRO/TRACKING/TRACK_ATTRIBUTE_SELECTION';

const actions = createActions({
  [TRACK]: (eventName, properties) => ({ eventName, properties }),
  [IDENTIFY]: (eventName, properties) => ({ eventName, properties }),
  [TRACK_ATTRIBUTE_SELECTION]: ({ attributeProperty, elementStyle }) => ({
    attributeProperty,
    elementStyle,
  }),
});

export default {
  actions: actions.designPro.tracking,
  selectors,
};
